import { render } from "./DesignPage.vue?vue&type=template&id=5c187ff0"
import script from "./DesignPage.vue?vue&type=script&lang=js"
export * from "./DesignPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__